module.exports = __webpack_public_path__ + "img/583.fbbfa73d.jpg";